import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { connect } from "react-redux";

import ProfileArticlePostComment from "../Innovators/ProfileArticlePostComment";
import Blocks from "./Blocks";

const PublishedArticle = ({
  _id,
  avatar,
  firstname,
  lastname,
  jobtitle,
  location,
  addReaction,
  likes,
  comments,
  comment,
  setshowArticle,
  addPostComment,
  setComment,
  keywords,
  blocks,
  articleimage,
  title,
  date,
  isAuthenticated,
}) => {
  const [showComments, setShowComments] = useState(false);
  return (
    <Fragment>
      <div className="article-overlay">
        <div className="article-overlay-box">
          <div className="article">
            <div className="poster">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/article_images/${articleimage}`}
                alt="article-avatar"
                className="trending-image"
              />
            </div>
            <div className="items-container-published">
              <p className="article-title">{title}</p>
              {keywords.length > 0 &&
                keywords.map((keyword) => {
                  return (
                    <li className="keywordsArray green">{keyword.text}</li>
                  );
                })}
              <div className="article-caption">
                <i className="far fa-clock mr-5 green"></i>
                <p className="caption">
                  Published <Moment format="MM/DD/YYYY">{date}</Moment>
                </p>
              </div>
              <div className="overlay-ellipsis">
                <div className="overlay-modal">
                  <ul className="modal-items">
                    <li className="modal-item">
                      <i className="fas fa-flag mx-5 white"></i>
                      Report
                    </li>
                    <li className="modal-item">
                      <i className="fas fa-ban mx-5 white"></i>
                      Block
                    </li>
                  </ul>
                </div>
                <i className="fas fa-ellipsis-v fa-lg green"></i>
              </div>
            </div>
            <div className="full-article-info">
              <div className="article-overlay-user">
                <div>
                  <div className="sub-user">
                    <div className="online-avi-container">
                      <div className="avi-color-border-alt green">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                          className="sub-avi"
                          alt="avi-two"
                        />
                      </div>
                    </div>
                    <div className="sub-info">
                      <ul className="user-online-items">
                        <li className="user-online-item">
                          <span className="name-font bold green">
                            {firstname} {lastname}
                          </span>
                        </li>
                        <li className="user-online-item">{jobtitle}</li>
                        <li className="user-online-item">
                          {location.city}, {location.state}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="phrase-top-container">
                  <p className="phrase-text">
                    <i className="fas fa-globe-americas fa-lg mx-5 green"></i>
                    Life is better when we innovate
                  </p>
                  <div className="phrase-bottom-container">
                    <p className="article-phrase">Together.</p>
                  </div>
                </div>
              </div>
              <div className="flex-only">
                {isAuthenticated && (
                  <div className="modal-action-buttons">
                    <div className="modal-action-items">
                      <div className="modal-action-button">
                        <i
                          className="far fa-thumbs-up modal-action-icon fa-lg"
                          onClick={() => addReaction(_id)}
                        ></i>
                      </div>
                      <p className="modal-action-text mx-5">
                        {likes.length > 0 && <span>{likes.length}</span>}
                      </p>
                    </div>
                  </div>
                )}
                <div
                  className="modal-action-buttons"
                  onClick={() => {
                    if (showComments) {
                      setShowComments(false);
                    } else {
                      setShowComments(true);
                    }
                  }}
                >
                  <div className="modal-action-items">
                    <div className="modal-action-button">
                      <i className="far fa-comment modal-action-icon fa-lg"></i>
                    </div>
                    <p className="modal-action-text mx-5">
                      {comments.length > 0 && <span>{comments.length}</span>}
                    </p>
                  </div>
                </div>
                {isAuthenticated && (
                  <div className="modal-action-buttons">
                    <div className="modal-action-items">
                      <div className="modal-action-button">
                        <i className="far fa-share-square modal-action-icon fa-lg"></i>
                      </div>
                      <p className="modal-action-text">Share</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="article-p white">
              <Blocks blocks={blocks} />
            </div>
            <div className="article-desc-comments">
              <i
                className="fas fa-times fa-3x article-x"
                onClick={() => setshowArticle(false)}
              ></i>
              <div className="article-comments">
                <div
                  className="comments-title cursor"
                  onClick={() => {
                    if (showComments) {
                      setShowComments(false);
                    } else {
                      setShowComments(true);
                    }
                  }}
                >
                  {!showComments && (
                    <div>
                      <i className="far fa-comment fa-lg mx-5 green"></i>
                      Comments
                    </div>
                  )}
                  {showComments && (
                    <div>
                      <i className="far fa-comment fa-lg mx-5 green"></i>
                      Hide Comments
                    </div>
                  )}
                </div>
                {showComments && (
                  <div>
                    {isAuthenticated && (
                      <div className="comment-reply-input-container-alt">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (comment !== "") {
                              addPostComment({ comment, _id });
                              setComment("");
                              setshowArticle(false);
                            }
                          }}
                          className="comment-reply-input-hidden"
                        >
                          <input
                            type="text"
                            className="comment-reply-input"
                            name="comment"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Enter your comment here..."
                          />
                          <button className="comment-reply-input-button background-green">
                            <i className="far fa-comments"></i>
                          </button>
                        </form>
                      </div>
                    )}
                    {comments.map((comment) => (
                      <ProfileArticlePostComment
                        key={comment._id}
                        comment={comment}
                        id={_id}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

PublishedArticle.propTypes = {
  auth: PropTypes.object.isRequired,
  addReaction: PropTypes.func.isRequired,
  removeLike: PropTypes.func.isRequired,
  addPostComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {})(PublishedArticle);
